import { Button } from '@material-ui/core';
import { BoxTitle, Paragraph } from '../../DeleteAccount/DeleteAccount.styles';
import { SimpleModal } from 'components/Modal';

interface DeletionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (e: any) => void;
    loading: boolean;
}

const DeleteModal = ({ isOpen, onClose, onConfirm, loading }: DeletionModalProps) => {
    return (
        <SimpleModal isOpen={isOpen} onClose={onClose}>
            <BoxTitle $titleColor="var(--labels-primary, #000)">Delete Account?</BoxTitle>
            <Paragraph>We will immediately cancel all booked shifts and remove all active offers. Are you sure you want to proceed?</Paragraph>
            <Button  
                variant="contained"
                color="secondary"
                size="medium"
                className="bigButtonInNewStyle"
                onClick={onConfirm}
                disabled={loading}>
                Delete Forever           
            </Button>
            <Button  
                variant="outlined"
                color="primary"
                size="medium"
                className="bigButtonInNewStyle"
                onClick={onClose}
                disabled={loading}>
                Go Back
            </Button>
        </SimpleModal>
    );
};

export default DeleteModal;